import { RootState } from '@/store'

export const getSelfEmploymentProfile = (state: RootState) => state.selfEmploymentProfile
